<template>
  <div class="flex items-center gap-2 flex-1">
    <div class="flex items-center gap-1.5 flex-1">
      <div class="flex items-center relative flex-1">
        <select
          class="form-field appearance-none"
          @change="changeSelectedProject"
        >
          <option value="">Select project</option>
          <option
            v-for="(project, key) in projects"
            :key="key"
            :value="project.uuid"
            :selected="selectedProject === project.uuid"
          >
            {{ project.name }}
          </option>
        </select>
        <span class="absolute right-3 pointer-events-none"
          ><ChevronDown :size="18" :stroke-width="1.75"
        /></span>
      </div>
      <div
        v-if="selectedProject"
        class="w-11 h-11 button primary-button p-0"
        @click="resetProjectFilter"
      >
        <X :size="18" :stroke-width="1.75" />
      </div>
    </div>
    <RouterLink :to="{ name: 'projects' }" class="button primary-button">
      <FolderOpenDot :size="20" :stroke-width="1.75" />
      Manage Projects
    </RouterLink>
  </div>
</template>

<script>
import { computed } from "vue";
import { useUserStore } from "../stores/user";
import ApiRequest from "../libs/ApiRequest";
import helper from "../libs/helper";
import { ChevronDown, FolderOpenDot, X } from "lucide-vue-next";
export default {
  setup() {
    const userStore = useUserStore();
    return {
      userStore: userStore,
      selectedProject: computed(() => userStore.selectedProject),
    };
  },
  components: {
    ChevronDown,
    X,
    FolderOpenDot,
  },
  data() {
    return { projects: null };
  },
  async mounted() {
    const { data } = await ApiRequest().get(`/api/serp/projects`);
    const { results = {} } = data;
    this.projects = helper.lodashOrder(results, "created_at", "desc");
    this.userStore.setProjects(this.projects);
  },
  unmounted() {
    this.userStore.setSelectedProject("");
  },
  methods: {
    changeSelectedProject(event) {
      this.userStore.setSelectedProject(event.target.value);
      this.$router.push("/serp/reports");
    },
    resetProjectFilter() {
      this.userStore.setSelectedProject("");
    },
  },
};
</script>
